/* eslint-disable react/no-array-index-key */
import React, { useRef, useState } from 'react';
import {
  FormControl,Grid, Checkbox, Chip, Typography, TextField,
} from '@material-ui/core';
import Button from 'src/components/sharedComponents/CustomButtons/Button';
import { Autocomplete } from '@material-ui/lab';
import useStyles from './styles';

const SpTopTen = ({topTen, onSubmitForm, forms }) => {
  const classes = useStyles();
  const [form, setForm] = useState({
    material: [],
    selectecType: [],
    totalTextFiltered: [],
    totalMaterialsFiltered: [],
  });
  const [customKey, setCustomKey] = useState(0)

  const extractValues = (array, prop) => {
    const extract = array.map((item) => item[prop].split('¬'));
    const result = extract.reduce((a, b) => a.concat(b));
    return result;
  };

  const handleChange = (value) => {
    setCustomKey(prevKey => prevKey + 1);
    if (value.length > 0) {
      const result = topTen.filter((e) => ['organizar'].every((a) => value.includes(e[a])));
      const resultsTexts = extractValues(result, 'Texto_breve_de_material');
      const resultsMaterials = extractValues(result, 'Material');
      setForm({
        ...form,
        material: resultsMaterials,
        totalTextFiltered: resultsTexts,
        totalMaterialsFiltered: resultsMaterials,
      });
    }
  };
  const onChange = (value) => {
    const codes = value.map(el => el.cod)
    setForm({ ...form, material: codes });
  };

  const optionsTop = topTen.map(name => name.organizar)
  const optionsMaterials = form.totalTextFiltered?.map((txt, i) => ({
    value: txt,
    cod: form.totalMaterialsFiltered[i],
  }));


  return (
    <form
      className={classes.containerCard}
      onSubmit={(e) => {
        e.preventDefault();
        onSubmitForm({ ...forms, material: form.material, type: forms.type, fechas: forms.fechas }, true, false);
      }}
    >
      <Grid container spacing={3} alignItems="center" sx={12}>
        <Grid item xs={2}>
          <FormControl variant="outlined" className={classes.formControl}>
            <Autocomplete
              freeSolo
              disableCloseOnSelect
              disableClearable
              label='Top 10'
              options={optionsTop}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label='Top 10'
                  variant="outlined"
                />
              )}
              renderOption={(option, { selected }) => (
                <>
                  <Checkbox
                    color="primary"
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option}
                </>
              )}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <Chip
                    label={<Typography>{option}</Typography>}
                    {...getTagProps({ index })}
                    style={{ backgroundColor: 'white', margin: '0 6px' }}
                  />
                ))}
              onChange={(e, value) => handleChange(value, 'marca')}
            />
          </FormControl>
        </Grid>
        <Grid item xs={3}>
          <FormControl variant="outlined" className={classes.formControl}>
            <Autocomplete
              freeSolo
              disableCloseOnSelect
              disableClearable
              multiple
              limitTags={1}
              label='Materiales'
              key={customKey}
              options={optionsMaterials}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label='Materiales'
                  variant="outlined"
                />
              )}
              renderOption={(option, { selected }) => (
                <>
                  <Checkbox
                    color="primary"
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option.value}
                </>
              )}
              renderTags={(value, getTagProps) => value.map((option, index) => (
                <Chip label={<Typography>{option.value}</Typography>}
                  {...getTagProps({ index })}
                  style={{ backgroundColor: 'white', margin: '0 6px' }}
                />
              ))}
              onChange={(e, value) => onChange(value)}
              getOptionLabel={(option) => option.value}
              getOptionSelected={(option, anotherOption) =>
    option.value === anotherOption.value}
            />
          </FormControl>
        </Grid>
        <Grid item xs={2} className={classes.button}>
          <Button type="onSubmit " color="warning" fullWidth>
            Filtrar
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default SpTopTen;
